<template>
  <div class="home-container" ref="homeContainer">
    <div class="search">
      <div class="search-title">
        <span>老师帮，您的专属AI工作助手</span>
        <img class="dpBanner" :src="dpBanner" />
      </div>
      <el-input
        v-model="content"
        class="search-input"
        placeholder="热门应用"
        @keydown.native="handleKeyDown"
        @focus="handleFocus"
      >
        <template #suffix>
          <div
            class="search-icon"
            :class="{ disabled: !content || content.trim() === '' }"
            @click="content && content.trim() !== '' ? search() : null"
          >
            <img :src="searchIcon" />
          </div>
        </template>
      </el-input>
    </div>
    <div v-if="isSearching" class="back-home" @click="backHome">
      <i class="back-home-icon"></i>
      <span>返回首页</span>
    </div>
    <div
      v-if="applicationList"
      :class="['content', { searching: isSearching }]"
    >
      <!-- tabs导航，搜索时隐藏 -->
      <div
        class="navtion"
        :class="{ scrolling: isScrolling }"
        v-if="!isSearching"
      >
        <div
          v-for="(category, index) in applicationList.columnList"
          :key="index"
          :class="{ actived: active === index }"
        >
          <span
            class="xinpin-icon"
            v-if="isXinPin && category.name === '新课标专区'"
          ></span>
          <a
            @click="
              handleTabClick('#category-' + category.id, index, category.name)
            "
            >{{ category.name === "热门助手" ? "热门应用" : category.name }}</a
          >
        </div>
      </div>
      <!-- 搜索和非搜索都正常渲染分类和标题 -->
      <template v-if="!isSearching">
        <div
          v-for="(category, index) in applicationList.columnList"
          :key="index"
          :id="'category-' + category.id"
          class="category"
        >
          <div
            v-if="applicationList.appList[category.id]"
            class="category-title"
          >
            {{ category.name === "热门助手" ? "热门应用" : category.name }}
          </div>
          <div class="application-container">
            <template v-if="category.name === '新课标专区'">
              <div class="new-standard" v-if="!isSearching">
                <i class="kebiao-icon"></i>
                <span>义务教育课标：</span>
                <div
                  v-for="(_item, _index) in applicationList.newStandardDocList"
                  :key="_index"
                  class="new-application"
                >
                  <a
                    class="new-standard-doc"
                    target="_blank"
                    :href="_item.link"
                    >{{ _item.name }}</a
                  >
                </div>
              </div>
              <div
                v-for="(_category, _index) in applicationList.newColumnList"
                :key="_index"
                :id="'category-' + _category.id"
                class="category-new-title"
              >
                <div class="newtitle">{{ _category.name }}</div>
                <div
                  v-for="(_app, _appIndex) in applicationList.newAppList[
                    _category.id
                  ]"
                  :key="_appIndex"
                  class="application"
                  @click="
                    openApp(
                      _app.appId,
                      _app.template,
                      _app.name,
                      _app.category,
                      _app.appSeoInfo,
                      _app
                    )
                  "
                >
                  <chat-applicaton :app-data="_app" />
                </div>
              </div>
            </template>
            <template v-else>
              <div
                v-for="(app, appIndex) in applicationList.appList[category.id]"
                :key="appIndex"
                class="application"
                @click="
                  openApp(
                    app.appId,
                    app.template,
                    app.name,
                    app.category,
                    app.appSeoInfo,
                    app
                  )
                "
              >
                <chat-applicaton :app-data="app" />
              </div>
            </template>
          </div>
        </div>
      </template>
      <!-- 搜索到的应用 -->
      <div v-if="isSearching" class="seash-category">
        <div
          v-for="(app, appIndex) in appSearchList"
          :key="appIndex"
          class="seash-application"
          @click="openApp(app.appId, app.template, app.name, app.category)"
        >
          <chat-applicaton :app-data="app" />
        </div>
      </div>
      <div v-if="isSearching" class="ai-assistant-btn" @click="openAiAssistant">
        <i></i>
        <span>没找到想要的应用？点击这里直接问AI老师助手</span>
      </div>
      <nb-book
        :dialogVipVisible="dialogVipVisible"
        :name="nbBookName"
        :url="nbBookUrl"
        @closePayActivity="closePayActivity"
      />
    </div>
    <div class="assistant-box" v-if="isSearching && isAIVisible">
      <ai-assistant
        :dialogVipVisible="isAIVisible"
        :searchContent="content"
        @close="closeAiAssistant"
      />
    </div>
    <div class="footer">
      <p>
        <a :href="companyintro" target="_blank">公司简介</a>
        <span>|</span>
        <a
          href="https://login.laoshibang.com/policy.html"
          target="_blank"
          rel="noopener noreferrer"
          >用户协议</a
        >
        <span>|</span>
        <a
          href="https://login.laoshibang.com/agreement.html"
          target="_blank"
          rel="noopener noreferrer"
          >隐私政策</a
        >
      </p>
      <p>北京世纪好未来教育科技有限公司<span>|</span>京ICP备13017119号-45</p>
    </div>
  </div>
</template>
<script>
import sensors from "sa-sdk-javascript";
import { addMyAppList, getApplicationList, appSearch } from "@/api/home";
import { Message } from "element-ui";
import { mapGetters } from "vuex";
import { nbBookDetall } from "@/api/chat";
import chatApplicaton from "./components/card";
import NbBook from "@/components/nbBook/index.vue";
import AiAssistant from "./components/AiAssistant.vue";
import { getLocalToken } from "@/utils/token";
import sObserver from "@/utils/simpleObserver";

export default {
  name: "Home",
  components: {
    chatApplicaton,
    NbBook,
    AiAssistant,
  },
  data() {
    return {
      content: null,
      dpBanner: require("@/assets/images/laoshibang/dpBanner.png"),
      searchIcon: require("@/assets/images/laoshibang/search-icon.png"),
      defaultChatUrl: require("@/assets/images/laoshibang/chat-default.png"),
      companyintro: `https://login${
        process.env.NODE_ENV === "production" ? "" : "-fz"
      }.laoshibang.com/company.html`,
      applicationList: [],
      active: 0,
      isAnchorClick: false,
      scrollListenerEnabled: true,
      targetScrollPosition: null,
      clickedIndex: undefined,
      isClickScroll: false,
      isScrolling: false,
      isXinPin: false,
      dialogVipVisible: false,
      nbBookUrl: "",
      nbBookName: "",
      isSearching: false,
      appSearchList: [],
      isAIVisible: false,
      hasCheckedPendingNbBook: false,
    };
  },
  computed: {
    ...mapGetters(["userId", "userInfo"]),
    isNotLogin() {
      return !getLocalToken("tal_token");
    },
  },
  watch: {
    userInfo: {
      handler(newVal) {
        if (newVal) {
          // this.getApplicationListFunc();
        }
      },
      deep: true,
      immediate: true,
    },
    isSearching: {
      handler(newVal) {
        if (!newVal) {
          this.isAIVisible = false;
        }
      },
      immediate: true,
    },
  },
  async mounted() {
    this.getApplicationListFunc();
    // 确保绑定到正确的滚动容器 app-main
    const scrollContainer = document.querySelector(".app-main");
    if (scrollContainer) {
      scrollContainer.addEventListener("scroll", this.handleScroll);
    }
    // const res = await getUserInfo();
    // if (res.code === 200) {
    //   this.$store.commit("user/SET_USERINFO", {
    //     data: { userInfo: { ...res.data } },
    //   });
    // }
    sensors.track("home_show");
    window.addEventListener("resize", this.handleResize);

    if (this.$route.query.nb) {
      this.nbBookName = this.$route.query.name;
      // 去掉链接中 nb参数
      this.$router.replace({
        query: {
          ...this.$route.query,
          nb: undefined,
          name: undefined,
          category: undefined,
          appId: undefined,
        },
      });
      if (this.isNotLogin) {
        // 存储 nobook 请求信息，等待登录成功后处理
        localStorage.setItem(
          "pendingNbBookRequest",
          JSON.stringify({
            name: this.nbBookName,
            timestamp: Date.now(),
          })
        );
        return sObserver.fire("laoshibang-login");
      }
      this.getNbBookDetail();
    }

    // 页面刷新后检查是否有待处理的 nobook 请求
    // 添加延迟确保在最后一次刷新后执行
    setTimeout(() => {
      this.checkPendingNbBookRequest();
    }, 300);

    // 恢复登录刷新前的输入内容
    const savedContent = localStorage.getItem("home_search_content");
    const fromLogin = localStorage.getItem("home_search_from_login");
    if (savedContent) {
      this.content = savedContent;
      localStorage.removeItem("home_search_content");
      if (fromLogin === "1") {
        // 只在登录场景下自动搜索
        this.$nextTick(() => {
          this.search();
        });
        localStorage.removeItem("home_search_from_login");
      }
    }
  },
  beforeDestroy() {
    const scrollContainer = document.querySelector(".app-main");
    if (scrollContainer) {
      scrollContainer.removeEventListener("scroll", this.handleScroll);
    }
    window.removeEventListener("resize", this.handleResize);
  },
  provide() {
    return {
      sendToAiAllready: this.alreadySendMessage,
    };
  },
  methods: {
    alreadySendMessage() {
      this.content = "";
    },
    handleResize: _.throttle(() => {
      // 处理窗口大小变化的逻辑
      console.log("窗口大小已改变");
      window.location.reload();
    }, 200), // 200毫秒内只执行一次
    /**
     * 搜索
     */
    search() {
      console.log("搜索");

      const params = {
        query: this.content,
      };
      // 新的搜索逻辑 20250709
      appSearch(params)
        .then((res) => {
          if (res.code === 200) {
            this.appSearchList = res.data;

            if (this.appSearchList.length === 0) {
              // 检查搜索结果是否为空且用户已登录
              if (!this.isNotLogin) {
                // 主动弹出AI助手弹窗
                this.isAIVisible = true;
              }
              sensors.track("chatbot_app_recom_click", {
                status: 0,
              });
            } else {
              sensors.track("chatbot_app_recom_click", {
                status: 1,
              });
            }
          } else {
            Message.error(res.msg);
          }
        })
        .catch((error) => {
          Message.error("网络异常，暂无数据");
          console.error("接口请求异常:", error);
        });

      console.log("appSearchList", this.appSearchList);
      // 搜索状态
      this.isSearching = !!this.content;
      // this.getApplicationList(params).then(data => {
      //   const status = !!data ? 1: 0;
      //   sensors.track("home_search_result_show", {
      //     status,
      //   });
      // });
      // sensors.track("home_search_confirm_click", {
      //   content: this.content,
      // });
      this.getApplicationListFunc(params).then((data) => {
        const status = data ? 1 : 0;
        sensors.track("home_search_result_show", {
          status,
        });
      });
      sensors.track("home_search_confirm_click", {
        content: this.content,
      });
    },
    /**
     * 获取应用列表
     */
    getApplicationListFunc(params) {
      // 初始化数据
      this.applicationList = [];
      this.isXinPin = false;
      return getApplicationList(params).then((res) => {
        if (res.code === 200) {
          console.log("获取应用列表 success", res);
          // 是否有新课标
          if (res.data?.hasNewStandardColumn) {
            this.isXinPin = true;
            this.applicationList = res.data;
            this.applicationList.columnList.unshift({
              id: Math.floor(Math.random() * 900) + 100,
              name: "新课标专区",
              appList: res.data.newStandardDocList,
            });
          } else {
            this.applicationList = res.data;
          }
          // 默认滚动到顶部
          this.active = 0;
          return res.data;
        } else {
          Message.error(res.msg);
        }
      });
    },

    // nb插件详情
    async getNbBookDetail() {
      try {
        const res = await nbBookDetall();
        if (res.code === 200) {
          this.dialogVipVisible = true;
          this.nbBookUrl = res.data.url;
        } else {
          Message.error(res.msg || "网络异常，暂无数据");
        }
      } catch (error) {
        Message.error("网络异常，暂无数据");
        console.error("接口请求异常:", error);
      }
    },
    /**
     * 打开应用
     */
    openApp(appId, isTemplate, name, category, appSeoInfo, app) {
      sensors.track("home_app_click", {
        name,
        app_id: appId,
        app_type: category,
        source: this.content ? "search" : "home",
      });

      // 特殊分类处理
      if (category === "htmlfile") {
        const aLink = document.createElement("a");
        aLink.href = `/code?appId=${appId}`;
        aLink.target = "_blank";
        aLink.click();
        return;
      }

      if (category === "nobook") {
        this.nbBookName = name;
        if (this.isNotLogin) {
          // 存储 nobook 请求信息，等待登录成功后处理
          localStorage.setItem(
            "pendingNbBookRequest",
            JSON.stringify({
              name: name,
              timestamp: Date.now(),
            })
          );
          return sObserver.fire("laoshibang-login");
        }
        this.getNbBookDetail();
        return;
      }

      // 构建路由参数
      const params = { appId, name };

      // 需要设置isTemplate的分类
      const templateCategories = [
        "miniprogram",
        "image2video",
        "aiquestion",
        "image2image",
      ];
      if (templateCategories.includes(category) || isTemplate) {
        params.isTemplate = isTemplate || 1;
      }

      // 埋点追踪详情页展示
      const eventName = params.isTemplate
        ? "conversation_app_table_show"
        : "conversation_app_detail_show";
      sensors.track(eventName, {
        source: "home",
      });

      // 路由跳转
      if (this.userId) {
        addMyAppList({ appId }).then((res) => {
          if (res.code === 200) {
            this.$router.push({
              name: "chat",
              params: {
                appSeoInfo: appSeoInfo,
              },
              query: params,
            });
          }
        });
      } else {
        localStorage.setItem("noLoginAppData", JSON.stringify(app));
        this.$router.push({
          name: "chat",
          params: {
            appSeoInfo: appSeoInfo,
          },
          query: params,
        });
      }
      appSeoInfo && (appSeoInfo.appId = appId);
      // 将appSeoInfo存储到localStorage
      localStorage.setItem("appSeoInfo", JSON.stringify(appSeoInfo));
    },
    handleKeyDown(e) {
      // 按shift+enter时不触发搜索
      if (e.key === "Enter" && e.shiftKey) {
        return;
      }

      if (e.key === "Enter" && !e.ctrlKey) {
        // 检查输入框是否为空，如果为空则不执行搜索
        if (!this.content || this.content.trim() === "") {
          return;
        }
        this.search();
      }
    },
    handleTabClick(anchor, index, name) {
      sensors.track("home_navigate_click", {
        name: name === "热门助手" ? "热门应用" : name,
      });
      if (this.isScrolling) {
        return;
      }
      this.clickanchor(anchor, index);
    },
    clickanchor(anchor, index) {
      this.isAnchorClick = true;
      this.active = index;
      this.scrollListenerEnabled = false;
      this.isClickScroll = true;
      this.clickedIndex = index;
      this.isScrolling = true;

      const element = document.querySelector(anchor);
      if (!element) {
        this.isScrolling = false;
        return;
      }

      this.targetScrollPosition = element.offsetTop;

      // Get the container element that should be scrolled
      const container = document.querySelector(".app-main");
      if (!container) {
        this.isScrolling = false;
        return;
      }

      // Calculate the target scroll position accounting for the header height
      const headerHeight = 40; // Height of the header
      const targetPosition = element.offsetTop - headerHeight;

      // Smooth scroll to the target position
      container.scrollTo({
        top: targetPosition,
        behavior: "smooth",
      });

      // 延长禁用滚动监听的时间，并在滚动完成后解除禁止点击状态
      setTimeout(() => {
        this.scrollListenerEnabled = true;
        this.isScrolling = false;

        // 保持点击滚动标记一段时间，确保滚动完全停止后才恢复自动高亮
        setTimeout(() => {
          this.isClickScroll = false;
        }, 500);
      }, 500);
    },
    handleScroll(e) {
      if (!this.scrollListenerEnabled) return;

      // 如果当前滚动是由点击导航标签触发的，则不执行自动高亮逻辑
      if (this.isClickScroll) {
        return;
      }

      // 获取当前分辨率
      const screenWidth = window.screen.width;
      const screenHeight = window.screen.height;
      // console.log(`当前分辨率: ${screenWidth}x${screenHeight}`);
      // 判断是否为 2K 分辨率（2560x1440）
      const is2KResolution = screenWidth === 2560 && screenHeight === 1440;

      const categories = this.applicationList.columnList;
      const headerHeight = 40; // header高度

      // 获取可视区域高度
      const viewportHeight = window.innerHeight;

      // 使用最接近视口中心的元素作为当前活动元素
      let closestDistance = Infinity;
      let currentActive = -1;

      // 计算视口中心位置

      const viewportCenter = is2KResolution
        ? headerHeight + viewportHeight / 7 // 2K 分辨率下调整为 1/7
        : headerHeight + viewportHeight / 5; // 其他分辨率保持 1/5

      for (let i = 0; i < categories.length; i++) {
        const category = categories[i];
        const element = document.getElementById(`category-${category.id}`);

        if (element) {
          const rect = element.getBoundingClientRect();

          // 计算元素中心点到视口中心的距离
          const elementCenter = (rect.top + rect.bottom) / 2;
          const distance = Math.abs(elementCenter - viewportCenter);

          // 如果元素在视口内并且是目前为止最接近中心的
          if (rect.bottom > headerHeight && distance < closestDistance) {
            closestDistance = distance;
            currentActive = i;
          }
        }
      }

      // 更新高亮状态
      if (currentActive !== -1) {
        this.updateActiveCategory(currentActive);
      }
    },
    // 添加一个新方法来处理活动标签的更新和滚动
    updateActiveCategory(index) {
      if (this.active !== index) {
        this.active = index;
        // 确保高亮的导航标签可见
        this.$nextTick(() => {
          const navtionContainer = document.querySelector(".navtion");
          if (navtionContainer) {
            const activeTab = navtionContainer.querySelector("div.actived");
            if (activeTab) {
              // 滚动导航栏以显示活动标签
              activeTab.scrollIntoView({
                behavior: "smooth",
                block: "nearest",
                inline: "center",
              });
            }
          }
        });
      }
    },
    handleFocus() {
      sensors.track("home_search_bar_click");
    },
    // 关闭nb插件弹框
    closePayActivity() {
      this.dialogVipVisible = false;
    },
    // 打开AI助手
    openAiAssistant() {
      sensors.track("home_search_result_assist_click", {
        resultNum: this.appSearchList.length,
      });
      if (this.isNotLogin) {
        // 登录前保存输入内容和登录标记
        localStorage.setItem("home_search_content", this.content);
        localStorage.setItem("home_search_from_login", "1");
        // 注册登录成功回调
        sObserver.fire("laoshibang-login-success", () => {
          // 登录成功后跳转回 home 页
          this.$router.push({ path: "/apps/index" });
        });
        sObserver.fire("laoshibang-login");
        return;
      }
      this.isAIVisible = true;
      this.$nextTick(() => {
        const container = document.querySelector(".app-main");
        if (container) {
          container.scrollTo({
            top: container.scrollHeight,
            behavior: "smooth",
          });
        }
      });
    },
    closeAiAssistant() {
      this.isAIVisible = false;
    },
    // 检查nobook
    checkPendingNbBookRequest() {
      if (this.hasCheckedPendingNbBook) return;
      this.hasCheckedPendingNbBook = true;
      const pendingRequest = localStorage.getItem("pendingNbBookRequest");
      if (pendingRequest) {
        try {
          const requestData = JSON.parse(pendingRequest);
          const now = Date.now();
          const requestTime = requestData.timestamp;
          const timeDiff = now - requestTime;
          if (timeDiff <= 5 * 60 * 1000) {
            this.nbBookName = requestData.name;
            this.getNbBookDetail();
          }
          // 清除已处理的请求
          localStorage.removeItem("pendingNbBookRequest");
        } catch (error) {
          console.error("nobook打开失败:", error);
          localStorage.removeItem("pendingNbBookRequest");
        }
      }
    },
    backHome() {
      this.isSearching = false;
      this.active = 0;
      this.content = "";
      const abTestInfo = JSON.parse(localStorage.getItem("abTestInfo"));
      if (abTestInfo?.strategy === "B") {
        this.$router.push({ path: "/home/index" });
      } else {
        this.$router.push({ path: "/apps/index" });
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.home-container {
  min-height: calc(100vh - 16px - 70px);
  padding: 16px 58px 0 0px;
  margin-left: 16px;
  display: flex;
  flex-direction: column;
}

.search {
  width: 100%;
  height: 256px;
  background: url("../../assets/images/laoshibang/bg.png");
  background-size: cover;
  display: flex;
  align-items: center;
  flex-direction: column;
  border-radius: 0 18px 18px 0;

  &-title {
    color: #fff;
    text-align: center;
    font-family: "PingFang SC";
    font-size: 40px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    padding: 46px 0 46px 0;
    display: flex;
    align-items: center;
    justify-content: center;

    .dpBanner {
      width: 165px;
      height: 30px;
      margin-left: 6px;
    }
  }
}

.search-input {
  width: 60%;
  height: 50px;
}

::v-deep .search-input .el-input__inner {
  background-color: #fff;
  height: 50px;
  border-radius: 8px;
  display: flex;
  align-items: center;
}

::v-deep .el-input__suffix {
  display: flex;
  align-items: center;
  height: 100%;
}
.xinpin-icon {
  position: absolute;
  left: 124px;
  top: 10px;
  width: 18px;
  height: 18px;
  background: url("../../assets/images/xinpin.png");
  background-size: cover;
}

.search-icon {
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  border-radius: 8px;
  background: linear-gradient(153deg, #0968eb -24.36%, #1a98f4 106.05%);

  &:hover {
    cursor: pointer;
  }

  &.disabled {
    background: #e4e7ed;
    cursor: not-allowed;
    opacity: 0.6;
    background: linear-gradient(153deg, #0968eb -24.36%, #1a98f4 106.05%);
    &:hover {
      cursor: not-allowed;
    }
  }
}

.category {
  margin-top: 60px;
  padding-top: 64px;
  margin-top: -64px;
  // scroll-padding-top: 64px;
  &-title {
    color: #0f0f10;
    font-family: "PingFang SC";
    font-size: 18px;
    font-style: normal;
    font-weight: 600;
    line-height: 22px;
    /* 122.222% */
    margin-bottom: 20px;
  }
}

.application-container {
  display: flex;
  flex-wrap: wrap;
}

.application {
  margin-right: 20px;
  margin-bottom: 20px;
  &:hover {
    cursor: pointer;
  }
}

.new-standard {
  width: 100%;
  span {
    font-family: PingFang SC;
    font-weight: 600;
    font-size: 14px;
    line-height: 22px;
    text-align: center;
    color: #333;
  }
  .kebiao-icon {
    position: relative;
    display: inline-block;
    left: 0;
    top: 4px;
    margin-right: 5px;
    width: 16px;
    height: 19px;
    background: url("../../assets/images/kebiaopdf.png");
    background-size: cover;
  }
}
.new-application {
  display: inline-block;
  padding: 0 8px;
  margin-bottom: 20px;
  a {
    font-family: PingFang SC;
    font-weight: 400;
    font-size: 14px;
    line-height: 22px;
    letter-spacing: 0px;
    text-align: center;
    text-decoration: underline;
    text-decoration-style: solid;
    text-decoration-skip-ink: auto;
    color: #0d70ed;
  }
}

.category-new-title {
  width: 100%;
  .newtitle {
    color: #0f0f10;
    font-family: "PingFang SC";
    font-size: 18px;
    font-style: normal;
    font-weight: 600;
    line-height: 22px;
    margin-bottom: 20px;
  }
  .application {
    display: inline-block;
  }
}

.content {
  // padding-bottom: 70px;
  margin-top: 0;
  flex: 1;
  &.searching {
    margin-top: 20px;
  }
}

.footer {
  width: 100%;
  height: 70px;
  padding-top: 10px;
  margin-top: 20px;
  background-color: #f5f5fa;
  font-family: PingFang SC;
  font-weight: 400;
  font-size: 12px;
  line-height: 18px;
  letter-spacing: 0px;
  text-align: center;
  color: rgba(50, 50, 51, 0.3);
  a:hover {
    color: #0d70ed;
  }
  span {
    margin: 0 8px;
  }
}

.content-default {
  width: 100%;
  height: calc(100% - 256px);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;

  &-img {
    width: 158px;
    height: 76px;
    flex-shrink: 0;
  }

  p {
    color: #717171;
    font-family: "PingFang SC";
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 14px;
    /* 100% */
  }
}

.navtion {
  width: 100%;
  position: sticky;
  top: 0px;
  margin-top: 40px;
  margin-bottom: 40px;
  height: 64px;
  flex-shrink: 0;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  border-radius: 12px;
  background: #fafcff;
  color: #0f0f10;
  text-align: center;
  font-family: "PingFang SC";
  font-size: 16px;
  font-style: 22px;
  font-weight: 600;
  line-height: 22px;
  z-index: 3;
  gap: 24px;
  padding: 0 40px;
  user-select: none;
  overflow-x: auto;
  white-space: nowrap; /* 防止内容换行 */
  -webkit-overflow-scrolling: touch; /* 平滑滚动 */
  div {
    padding: 0 8px;
  }

  a {
    white-space: nowrap;
  }

  &.scrolling {
    a {
      cursor: not-allowed;
      // opacity: 0.7;
      pointer-events: none;
    }
    div.actived a {
      opacity: 1;
    }
  }
}
.navtion::-webkit-scrollbar {
  display: none;
}
.actived {
  height: 64px;
  // width: 64px;
  color: #0d70ed;
  text-align: center;
  font-family: "PingFang SC";
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 64px;
  border-bottom: #0d70ed solid 5px;
}
.back-home-icon {
  width: 20px;
  height: 20px;
  display: inline-block;
  background: url("../../assets/images/laoshibang/back-home.png");
  background-size: cover;
}
.back-home {
  cursor: pointer;
  display: flex;
  justify-content: left;
  margin-top: 20px;
  span {
    font-family: PingFang SC;
    font-weight: 500;
    font-size: 18px;
    line-height: 100%;
    letter-spacing: 0px;
    margin-left: 7px;
  }
}
.ai-assistant-btn {
  display: flex;
  justify-content: left;
  align-items: center;
  margin-top: 20px;
  width: 418px;
  height: 60px;
  border-radius: 82px;
  border: 2px solid transparent;
  background: linear-gradient(#fff, #fff) padding-box,
    linear-gradient(90.49deg, #0d70ed 2.77%, #4696ff 33.14%, #2fc8ff 100.29%)
      border-box;
  box-sizing: border-box;
  cursor: pointer;
  i {
    margin-left: 8px;
    height: 45px;
    width: 45px;
    display: inline-block;
    background: url("../../assets/images/laoshibang/ai-zs.png");
    background-size: cover;
  }
  span {
    margin-left: 10px;
    font-family: PingFang SC;
    font-weight: 600;
    font-size: 16px;
    letter-spacing: 0px;
    color: #323233;
  }
}
.seash-category {
  display: flex;
  flex-wrap: wrap;
  overflow-x: unset;
  align-items: flex-start;
}
.seash-application {
  flex: 0 0 auto;
  cursor: pointer;
  margin-right: 20px;
  margin-bottom: 20px;
}
.assistant-box {
  width: 99.5%;
  height: 556px;
  margin-top: 15px;
  border-radius: 20px;
  border: 1px solid;

  border-image-source: linear-gradient(
    180deg,
    #ffffff 0%,
    rgba(255, 255, 255, 0.15) 99.07%
  );

  background: rgba(248, 250, 255, 0.76);

  // box-shadow: 0 0 10px 5px rgba(0, 0, 0, 0.5);
  box-shadow: -1px 2px 25.1px 0px rgba(146, 146, 146, 0.08);

  backdrop-filter: blur(17.5px);
  -webkit-backdrop-filter: blur(17.5px);
}
</style>
